import clsx from 'clsx';
import { ReactNode } from 'react';
import { spacing } from '../../lib/constants';

interface Props extends BaseProps {
  children: ReactNode;
  padding?: StandardSizes | 'none';
  spacing?: NumberVariants;
}

export const SectionContent = (props: Props) => {
  const { children, className, padding = 'md', spacing = 'none' } = props;
  const classes = useStyles();

  return (
    <div
      className={clsx(
        className,
        classes.default,
        classes.padding[padding],
        classes.spacing[spacing]
      )}
    >
      {children}
    </div>
  );
};

const useStyles = () => ({
  default: 'flex flex-col',
  padding: {
    none: 'p-0',
    sm: 'px-1 py-2',
    md: 'px-2 py-2',
    lg: 'px-4 py-2',
  },
  spacing: spacing,
});
